
import {Component, Vue} from "vue-property-decorator";
import {
  currentUserModule,
  dataFieldsEditModule,
  studyDefinitionModule, studyInstitutesModule,
  studyModule,
  studyPatientModule
} from "@/store";
import DataFields from "@/components/study/DataFields.vue";
import {convertToCreateDtos} from "@/auxillary/datafield.cache.helpers";
import {deepCopy} from "@/auxillary";
import {MdbsCore} from "@/api/tsclient";
import Rights = MdbsCore.Rights;

@Component({
  components: {DataFields}
})
export default class PatientNewView extends Vue {

  instituteId: string = "";

  saving = false;
  private snackbarText = "";
  private showSnackbar = false;
  private snackbarColor = "success";

  get loading() {
    return studyInstitutesModule.isLoading || studyModule.isLoading || studyDefinitionModule.isLoading;
  }

  get studyId() {
    return studyModule.study.id;
  }

  get isValid() {
    // TODO Demo Hack
    // basic check for required field
    return dataFieldsEditModule.dataFields.every(
        d => !d.isVisible || d.values.value != null
    )
  }

  get canNotCreate(){
    return !currentUserModule.hasRight(Rights.StudyPatientCreateCmd)
  }

  get institutes() {
    return studyInstitutesModule.studyInstitutes
        .filter(i => i.studyId == this.studyId)
        .sort((a, b) => (a.displayName ?? "") > (b.displayName ?? "") ? 1 : -1);
  }

  async mounted() {
    await studyInstitutesModule.loadAll(); // TODO only load my if possible
    // preselect a institute
    const studyInstitute = studyInstitutesModule.studyInstitutes[0]
    this.instituteId = studyInstitute.id;
    await studyModule.loadById(studyInstitute?.studyId ?? "")
    await studyDefinitionModule.loadById(studyModule.study?.studyDefinitionId ?? "")
    dataFieldsEditModule.setEditable(!this.canNotCreate);
    await dataFieldsEditModule.loadDataFields({
      definitions: studyDefinitionModule.studyDefinition.patient?.fields ?? [],
      dataFields: []
    })
  }

  async cancel() {
    await this.$router.push({name: 'patients'})
  }

  async createPatient() {
    this.saving = true

    const studyId = studyModule.study.id
    const studyInstituteId = this.instituteId;
    const fields = convertToCreateDtos(dataFieldsEditModule.dataFields)

    await studyPatientModule.create({
      studyId,
      studyInstituteId,
      fields
    })

    if (studyPatientModule.studyPatient?.validationMessages != null) {
      // if saving attempt failed, the returning dto needs to be shown with their errors
      await dataFieldsEditModule.loadDataFields({
        definitions: studyDefinitionModule.studyDefinition.patient?.fields ?? [],
        dataFields: studyPatientModule.studyPatient.fields ?? [],
        validationMessages: studyPatientModule.studyPatient?.validationMessages
      })

      const messages = deepCopy(studyPatientModule.studyPatient?.validationMessages ?? [])
      dataFieldsEditModule.setValidationMessages(messages);
    } else {
      dataFieldsEditModule.setValidationMessages([])
    }

    if (studyPatientModule.studyPatient.id != null && studyPatientModule.studyPatient.canSave) {
      this.showCreateSucceededSnackBar()
      // open new patient
      await this.$router.push({
        name: 'patient',
        params: {patientId: studyPatientModule.studyPatient.id}
      })
    }

    this.showCreateFailedSnackBar();

    this.saving = false
  }

  showCreateSucceededSnackBar() {
    this.snackbarColor = "success";
    this.snackbarText = "Patient wurde erfolgreich angelegt."
    this.showSnackbar = true;
  }

  showCreateFailedSnackBar() {
    if (studyPatientModule.studyPatient?.validationMessages?.some(v => v.messageType == "error"))
      this.snackbarColor = "error";
    else
      this.snackbarColor = "warning";
    this.snackbarText = "Invalide Daten, Patient konnte nicht angelegt werden."
    this.showSnackbar = true;
  }

}
